<div class="status" ngClass="{{status | lowercase}} {{textSize}}" fxLayout="row" fxLayoutAlign="center center">
    @if (icon) {
        <ui-kit-svg [name]="icon" class="i-16"/>
    }
    <div [class.ml-4]="icon">{{ statusText | translate }}</div>
</div>
